export default __webpack_public_path__ + "static/media/teacher_note_pin.75d534f3.svg";